import { Link } from 'react-router-dom';
import { articleCards } from '@/mocks/categories';

export default function ArticleCards() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold tracking-wider uppercase mb-3">
            Shopping Guides &amp; Resources
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            Complete Vigorbuy Spreadsheet Resources
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto text-sm md:text-base">
            In-depth guides to help you master every aspect of organized product research. From safety to category breakdowns, we have you covered.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {articleCards.map((article) => (
            <Link
              key={article.id}
              to={article.link}
              className="group flex flex-col rounded-xl bg-background-100 border border-background-200/60 hover:border-primary-300/50 transition-all duration-300 cursor-pointer overflow-hidden"
            >
              <div className="relative w-full h-44 md:h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 rounded-full bg-background-50/90 backdrop-blur-sm text-foreground-800 text-[10px] font-semibold">
                    {article.readTime}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <h3 className="font-heading font-semibold text-foreground-900 text-sm md:text-base mb-2 group-hover:text-primary-600 transition-colors leading-snug">
                  {article.title}
                </h3>
                <p className="text-foreground-600 text-xs leading-relaxed flex-1">
                  {article.excerpt}
                </p>
                <div className="mt-3 flex items-center gap-1.5 text-primary-600 text-xs font-medium">
                  <span>Read Article</span>
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform duration-200"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-shopping-cart-line"></i>
            Browse All Products on Main Website
          </a>
        </div>
      </div>
    </section>
  );
}